import React, { useCallback, useEffect } from 'react';

import { useAuth } from '../../hooks/auth';
import HomeBeneficiary from './Beneficiary';
import HomeCompany from './Company';
import { useOnlineMode } from '../../hooks/useOnlineMode';
import Wallet from '../Wallet';
import QuestionnaireService from '../../services/modules/questionnaire/questionnaire.service';
import Modal2 from '../../components/Modal2';
import QuestionnaireForm from '../../components/Modal2/presets/QuestionnaireForm';

const Home: React.FC = () => {
  const { user, isAuthendicated } = useAuth();
  const { isOnline } = useOnlineMode();

  const getQuestionSystem = useCallback(async () => {
    try {
      const data = await QuestionnaireService.getQuestionnaire();
      Modal2.Generic({
        closable: true,
        autoWidth: true,
        children: (
          <QuestionnaireForm
            data={data}
            enterpriseWebUserName={
              user.profile === 2 ? user.webUsername : undefined
            }
          />
        ),
      });
    } catch (error) {
      console.error('Failed to fetch questionnaire:', error);
    }
  }, [user]);

  useEffect(() => {
    if (isAuthendicated) {
      getQuestionSystem();
    }
  }, [isAuthendicated, getQuestionSystem]);

  switch (user.profile) {
    case 1:
      if (isOnline) return <HomeBeneficiary />;
      return <Wallet />;
    default:
      return <HomeCompany />;
  }
};

export default Home;
